import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

import closeIcon from "../../../../Assets/close-icon.svg"
import FormikControl from '../../../formik/FormikControl';
import AddButton from '../../../AddButton/AddButton';
import { serviceConsumer } from '../../../../network/ServiceConsumer';
import Loader from '../../../Loader/Loader';
import AdjudicatorStatus from '../../../AdjudicatorStatus/AdjudicatorStatus';
import { ShowToastMessage } from '../../../../helper/ShowToastMessage';

const STATUS_NOTE = {
    active: "Has a Feis.link account.",
    invited: "Invited to set up their account; waiting for them to accept.",
    email: "Their account invitation goes to the email already saved.",
};

//this modal shows all old collaborators, where we can select one
//works for adjudicators and musicians in feis,examiners in grade. Sponsors cannot be selected from old collaborators
const SelectCollaborators = ({ setOpenCollabModal, openCollabModal, getCollab, setOpenNewCollabModal, allowAddNew = true }) => {

    const [collaborators, setCollaborators] = useState([]);
    const [statusById, setStatusById] = useState({});
    const isAdjudicator = openCollabModal === "adjudicator";
    const [loading, setLoading] = useState(false);
    let EventID = localStorage.getItem('ID');

    useEffect(() => {
        getCollaboratorData();
    }, []);

    const getCollaboratorData = async () => {
        //get data to show in options of select
        try {
            setLoading(true);
            const url = `${process.env.REACT_APP_BASE_URL}/people/${openCollabModal}`;
            const response = await serviceConsumer('GET', url);
            const collabData = response.people.map((collab) => {
                return {
                    key: collab.fname ? `${collab.fname} ${collab.lname}`.trim() : collab.name,
                    value: collab._id,
                };
            })
            setCollaborators(collabData);
            // adjudicator account state, never the email (card 930d3ac0)
            setStatusById(Object.fromEntries(response.people.map((c) => [c._id, c.accountStatus])));
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    //Initial values for formik
    const collaboratorInitialValues = {
        collaborator: '',
        email: '',
    };

    //Validation Schema for Formik
    const collaboratorValidationSchema = Yup.object().shape({
        collaborator: Yup.string()
            .trim()
            .label('First Name:')
            .required('This field is required.')
            .nullable()
            .max(50),
        email: Yup.string().trim().email('Enter a valid email address.'),
    });

    // submit Handler
    const addCollabHandler = async (values) => {
        const type = openCollabModal === "examiner" ? "grade-exam" : "people";
        const url = `${process.env.REACT_APP_BASE_URL}/${type}/${openCollabModal}`;
        const payload = {
            eventId: EventID,
            peopleId: values.collaborator,
            // only for the judge chosen now, and only when they have no email yet
            ...(isAdjudicator && (statusById[values.collaborator] || "none") === "none" && values.email.trim()
                ? { email: values.email.trim() }
                : {}),
        };
        try {
            setLoading(true);
            const response = await serviceConsumer('POST', url, payload);
            if (response.success === true) {
                if (response.inviteError) ShowToastMessage("error", `Added, but the invitation wasn't sent: ${response.inviteError}`);
                else if (payload.email) ShowToastMessage("success", "Added, and the account invitation is on its way.");
                setOpenCollabModal("");
                getCollab();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            ShowToastMessage("error", error?.messages || "Something went wrong");
        }
    };

    const closeModalHandler = () => {
        setOpenCollabModal("");
    }

    const openNewCollabModal = () => {
        let modalName = openCollabModal
        setOpenCollabModal("");
        setOpenNewCollabModal(modalName)
    }

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <>
            {loading && <Loader />}
            <div style={{ padding: '100px', overflow: 'scroll' }}>
                <Modal className="addDancerScroll" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }} open={true}>
                    <Box>
                        <div style={{ maxHeight: '100vh', padding: '5px 100vw', overflow: 'scroll', }}>
                            <div className="main-div-adj">
                                <div className="close-div mt-4 mb-1">
                                    <img src={closeIcon} alt="close-icon" className="close-icon" onClick={closeModalHandler} />
                                </div>
                                <p className="color-subtitle text-center mb-4"> {`Add ${capitalizeFirstLetter(openCollabModal)}`}</p>
                                <div className="d-flex align-items-center justify-content-center" style={{ background: 'white,borderRadius: 14px;' }}>
                                    <Formik
                                        initialValues={collaboratorInitialValues}
                                        validationSchema={collaboratorValidationSchema}
                                        onSubmit={addCollabHandler}
                                    >
                                        {(formik) => (
                                            <Form
                                                className="form form-label-right"
                                                autoComplete="off"
                                            > 
                                                <div className={(formik.errors?.collaborator && formik.touched?.collaborator) ? '' : 'input-control'}>
                                                    <label className={(formik.touched?.collaborator && formik.errors?.collaborator) ? 'select-label-error' : 'select-label'} htmlFor='input-box-org-select'>
                                                        {`${capitalizeFirstLetter(openCollabModal)}`}:
                                                    </label>
                                                    <FormikControl
                                                        className={(formik.touched?.collaborator && formik.errors?.collaborator) ? "input-box-org-select-error" : "input-box-org-select"}
                                                        control="select"
                                                        name="collaborator"
                                                        options={collaborators}
                                                        showAs="Select"
                                                        style={{ color: 'black' }}
                                                        id="AddAdjucator"
                                                        setFieldValue={formik.setFieldValue}
                                                        onChange={(e) => {
                                                            formik.setFieldValue("collaborator", e.target.value);
                                                            // an email typed for one judge never goes with another
                                                            formik.setFieldValue("email", "");
                                                        }}
                                                    />
                                                </div>
                                                {isAdjudicator && formik.values.collaborator && (() => {
                                                    const status = statusById[formik.values.collaborator] || "none";
                                                    if (status !== "none") {
                                                        return <div className="mb-3" style={{ maxWidth: "290px", fontSize: "13px", color: "#797979" }}>
                                                            <AdjudicatorStatus status={status} /> {STATUS_NOTE[status]}
                                                        </div>;
                                                    }
                                                    return <div className={(formik.errors?.email && formik.touched?.email) ? 'd-grid mb-3' : 'input-control d-grid mb-3'}>
                                                        <label className="label-head-org">Adjudicator's email:</label>
                                                        <input
                                                            className={(formik.errors?.email && formik.touched?.email) ? 'input-box-org-error' : 'input-box-org'}
                                                            type="email"
                                                            name="email"
                                                            placeholder="name@example.com"
                                                            value={formik.values.email}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.errors?.email && formik.touched?.email && <div className="auth-error">{formik.errors.email}</div>}
                                                        <span style={{ maxWidth: "290px", fontSize: "12px", color: "#797979", marginTop: "4px" }}>
                                                            We'll email them an invitation to set up their Feis.link adjudicator account.
                                                        </span>
                                                    </div>;
                                                })()}
                                                {allowAddNew && <>
                                                <span className="DidnontFind"> Didn't find the {`${capitalizeFirstLetter(openCollabModal)}`}?</span>


                                                <div className=" d-flex justify-content-center mt-4">
                                                    <AddButton className="plusIconbtn" onClick={openNewCollabModal} from="collab">
                                                        Add new {openCollabModal}
                                                    </AddButton>
                                                </div>
                                                </>}
                                                <div className="mb-5 d-flex justify-content-center ">
                                                    <button className={formik.isValid && formik.dirty ? 'filled' : 'disabled'}
                                                        type="submit"
                                                        disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                                                    >
                                                        Continue
                                                    </button>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        </>
    )
}

export default SelectCollaborators